export enum Reference {
  FlowType = 200,
  InvoiceStatus = 201,
}
